module.exports = __webpack_public_path__ + "img/map1.34438a64.png";